import { useEffect, useState } from "react";
import { signal } from "@preact/signals-react";
import { useQuery } from "@tanstack/react-query";
import JsQrReader from "./Components/JsQrReader";

import PureModal from "components/Modals/PureModal";
import Board from "components/Meta/Board";
import ModelSale from "./Model/ModelSale";
import ModelShipmentInternal from "./Model/ModelShipmentInternal";
import ModelShipmentOut from "./Model/ModelShipmentOut";
import PanelRight from "components/Panel/PanelRight";
import StdButton from "components/Buttons/StdButton";
import { getStorage, setStorage } from "store/local";
import proxy from "api/proxy";

const open = signal(false);
const data = signal(null);
const dom = signal(false);
const _ctxView = signal([]);
const view = signal("sale");
const statusSection = signal(true);

const ScreenQrSale = ({ config }) => {
  const ctxSession = getStorage("ctxSession");
  console.log(ctxSession);

  const permitShipmentInternal = ctxSession.groups.some(
    (item) => item.name === "Administración de logística" || item.id === 7,
  );
  const { data: warehouse } = useQuery({
    queryKey: ["get_user", ctxSession],
    queryFn: async () => {
      const locations = ctxSession.locations;
      let warehouse = ctxSession.warehouse;
      if (!locations) {
        const { data, error } = await proxy.search(
          "res.user",
          [["id", "=", ctxSession?.user]],
          [
            "id",
            "warehouse.name",
            "warehouse.input_location",
            "warehouse.storage_location",
          ],
        );
        if (data && data.length > 0) {
          warehouse = data[0]["warehouse."];
          const session_ = { ...ctxSession };
          session_.locations = [warehouse.id];
          session_.warehouse = warehouse;
          session_._skip_warnings = true;
          await setStorage("ctxSession", session_);
        }
      }
      return warehouse;
    },
  });

  const config_ = { ...config, warehouse };
  const ctxView = ModelSale.ctxView(config_);
  const ctxViewShipment = ModelShipmentInternal.ctxView(config_);
  const ctxViewShipmentOut = ModelShipmentOut.ctxView(config_);

  if (dom.value) {
    _ctxView.value = ctxView;
    _ctxView.value.domain = dom.value;
  }

  const getProducts = async () => {
    const fields_names = ["name", "id"];
    const { data: products } = await proxy.search(
      "product.product",
      [],
      fields_names,
    );
  };

  useEffect(async () => {
    getProducts();
    const { data: data2, error } = await proxy.getFields("sale.sale", []);
    console.log(data2, "data");
  }, []);

  const handleQrSearch = (result) => {
    if (result?.text) {
      data.value = result.text;
      open.value = false;
      dom.value = ["number", "ilike", data.value];
    }
  };

  const ContentScanQr = () => {
    return (
      <div className="overflow-hidden rounded-md">
        <JsQrReader onResult={handleQrSearch} />
        {data.value && <p>QR Data: {data.value}</p>}
      </div>
    );
  };

  return (
    <div className="w-full">
      {dom.value}
      <div className="flex flex-col-reverse lg:flex-row lg:space-x-10">
        <div
          className={
            statusSection.value == true
              ? "w-full md:w-[65vw] xl:w-[68vw]"
              : "w-full md:w-12/12 relative md:pr-10"
          }
        >
          <div className="my-3 lg:mx-4 w-full">
            {view.value === "sale" && <Board ctxView={ctxView} />}
            {view.value === "internal_shipments" && (
              <Board ctxView={ctxViewShipment} level="main" />
            )}
            {view.value === "internal_shipments_out" && (
              <Board ctxView={ctxViewShipmentOut} level="main" />
            )}
          </div>
        </div>
        <div className="md:w-[20vw] w-full">
          <PanelRight
            position={"right"}
            widgets={["status", "numPeople"]}
            title=""
            bgColor={statusSection.value ? "bg-gray-100" : "bg-sky-950"}
            status={statusSection.value}
            handleChangeStatus={false}
            displayOpen={true}
            style="bg-gray-100 px-2 custom-transition duration-500 sticky !w-full flex"
          >
            <div className="flex flex-col  md:space-x-0 w-full space-y-3 md:space-y-3 ">
              <StdButton
                content="button.qr_sale"
                size="w-full"
                color={view.value == "create" ? "rose" : "green"}
                onClick={() => {
                  view.value = "sale";
                }}
              />
              {permitShipmentInternal && (
                <StdButton
                  content="button_internal_sale.qr_sale"
                  size="w-full"
                  onClick={() => (view.value = "internal_shipments")}
                  color={"indigo"}
                />
              )}
              <StdButton
                content="button_devolution.qr_sale"
                size="w-full"
                onClick={() => (view.value = "internal_shipments_out")}
                color={"black"}
              />
            </div>
          </PanelRight>
        </div>
      </div>
      <div className=""></div>
      <PureModal
        open={open.value}
        onClose={() => (open.value = false)}
        backdrop={true}
        width="w-[440px]"
        overflow="!overflow-hidden"
      >
        {open.value && <ContentScanQr />}
      </PureModal>
    </div>
  );
};

export default ScreenQrSale;
